module.exports = __webpack_public_path__ + "static/img/nav_bg_fixed.e2f25df9.png";